import React, { PureComponent, memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FieldTableCustomColumnIds from '../../../../constants/FieldTableCustomColumnIds';
import FieldModes from '../../../../constants/FieldModes';
import FieldTypes from '../../../../constants/FieldTypes';
import Button from '../../../misc/Button';
import ThemeIcons from '../../../../theme/Icons';

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  width: 100%;
  padding: ${(props) => props.padding}px;
  background-color: ${(props) => props.backgroundColor};
  border-top: ${(props) => (props.borderTop ? props.borderTop : 'transparent')};
  border-right: ${(props) => (props.borderRight ? props.borderRight : 'transparent')};
  border-left: ${(props) => (props.borderLeft ? props.borderLeft : 'transparent')};
  border-bottom: ${(props) => (props.borderBottom ? props.borderBottom : 'transparent')};
  border-radius: ${(props) => (props.borderRadius != null ? `0 0 ${props.borderRadius}px ${props.borderRadius}px` : '0')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  svg {
    font-size: 12px;
  }
`;

class TableFooter extends PureComponent {

  static propTypes = {

    id: PropTypes.string,
    fieldMode: PropTypes.string,
    fieldType: PropTypes.string,

    //Action handlers
    onLoadCompleted: PropTypes.func,

    //Styles
    fontSize: PropTypes.number,
    fontColor: PropTypes.string,
    fontStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    textAlign: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.number,
    borderRadius: PropTypes.number,
    backgroundColor: PropTypes.string,
    padding: PropTypes.number,

  }

  constructor(props) {
    super(props);
    this.state = {
      rowRef: null,
    };
  }

  componentDidUpdate() {

    const { onLoadCompleted, loadCompletedId } = this.props;
    const { rowRef } = this.state;

    if (onLoadCompleted && rowRef) onLoadCompleted(loadCompletedId || 'footer', { height: rowRef.offsetHeight });

  }

  render() {

    const {
      id,
      disabled,

      borderColor,
      borderWidth,
      borderRadius,
      backgroundColor,
      padding,

      onRowCreate
    } = this.props;

    /**
     * We join width and color to a single border style because chrome displays
     * the border as a two tone color if you use border-color and border-width
     * indvidually.
     */
    const border = `${borderWidth}px solid ${borderColor}`;

    return (
      <StyledRow
        data-testid={`${id}-table-field-header-row`}
        ref={(e) => {
          const { rowRef } = this.state;
          if (!rowRef) this.setState({ rowRef: e });
        }}
        {...{
          border,
          backgroundColor,
          padding,
          borderRadius
        }}
      >
        {disabled ? null : <Button styles={{ padding: '2px 0px', width: '100%' }} icon={ThemeIcons.misc.add} onClick={onRowCreate} />}
      </StyledRow>
    );

  }

}

export default memo(TableFooter);
